module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAARhJREFUaAXtmE0KwjAQhRv/cO8VBEG8hjsP5caNh/ICHkI8gLgUV/FlMW4a2iFNMgReIIRO56fzvRaSdh2HLQE3pbz3fof4bUKOj3PulhCXNwQNXDBTxjPXk8xyJbLKwwasyEtdKiAkrFYqYEVe6lIBIWG1UgEr8lKXCggJq7V5BRz2wnfQOyQSXCJunhDrEfNNiJOQPc4Tj3CxwFxhrsNFxREOUlNq/g9izb9CbKDiaxctRQWiWCoaqUBF2NFSVCCKpaKRClSEHS3VvAJhM3fF3ETbGzee4HIcd+t5vGE596x6w0vvOuCJrTj/Tg/wUd1q/htgAyqdCzpRgYJwVampgApTQScqUBCuKjUVUGEq6EQFCsJVpf4BJW+GVXqhEnYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plus_sign_white.png
// module id = 258
// module chunks = 0